import React, {useContext} from "react";
import {BoShowContext} from "../context/bo-show-context.jsx";
import {BoKeys} from "../../resources/bo-keys.js";
import {getIndividualLabel, isBoImageExtension} from "../utils/bo-show-utils.js";
import InputCheckbox from "../../../../../components/input/input-checkbox.jsx";
import {getAssetPath} from "../../../../../utils/get-asset-path.js";

const BoShowStolenItems = () => {
    const {boData, verifySyncUrl, printOptions, attachesToHide, handleAttachToHide, setModalAttach} = useContext(BoShowContext);
    const stolenItemList = boData?.stolenItemList;

    if (!stolenItemList?.length) return null;

    const openModal = (relatedPhotoFace) => {
        if (!relatedPhotoFace) return;

        setModalAttach({open: true, attach: relatedPhotoFace})
    }

    return (
        <>
            {
                stolenItemList.map((stolenItem, index) => {
                    const attachment = stolenItem?.attachs?.[0];
                    if (attachment) {
                        attachment.url = `${verifySyncUrl(attachment.attachId)}/${attachment.attachId}`;
                    }

                    return (
                        <article key={stolenItem?.itemId ?? index} className={"space-y-4"}>
                            <h2 className={"resume-title"}>ITEM SUBTRAÍDO - {index + 1}</h2>

                            <section className={"grid grid-cols-12 gap-2"}>
                                <div className={"col-span-4"}>
                                    <div className={"image relative"}>
                                        {
                                            printOptions?.image && attachment?.attachId &&
                                            <InputCheckbox
                                                id={"attach-check-" + attachment.attachId}
                                                checked={!attachesToHide.includes(attachment.attachId)}
                                                label={"Exibir"}
                                                onChange={() => handleAttachToHide(attachment.attachId)}
                                                className={"absolute top-[5px] left-[10px] print:hidden"}
                                            />
                                        }
                                        <img
                                            className={(printOptions?.image && !attachesToHide.includes(attachment?.attachId) ? "print:block" : " print:hidden")}
                                            src={
                                                !!attachment ? isBoImageExtension(attachment?.extension)
                                                    ? (attachment?.attachId ? `${verifySyncUrl(attachment.attachId)}/${attachment.attachId}` : getAssetPath("img/no-img.png"))
                                                    : getAssetPath(`img/file-types/${attachment?.name?.split(".")?.pop()}.png`) : getAssetPath("img/no-img.png")
                                            }
                                            alt={`Apreensão ${index + 1}`}
                                            onClick={() => openModal(attachment)}
                                        />
                                        <img
                                            className={"hidden" + (!attachment?.attachId || (!printOptions?.image || attachesToHide.includes(attachment.attachId)) ? " print:block" : "")}
                                            src={getAssetPath("img/no-img.png")}
                                            alt=""
                                        />
                                    </div>
                                </div>

                                <div className={"col-span-8 grid grid-cols-3 gap-2 self-start"}>
                                    <p className={"col-span-3"}>Indivíduo: <span className={"info"}>{getIndividualLabel(boData?.individualList, stolenItem?.relatedPerson)}</span></p>
                                    <p className={"col-span-2"}>Tipo: <span className={"info"}>{stolenItem?.type ?? ""}</span></p>
                                    <p>{stolenItem?.type === "Celular" ? "IMEI" : "Subtipo"}: <span className={"info"}>{stolenItem?.type === "Celular" ? (stolenItem?.imei ?? "") : (stolenItem?.subtype ?? "")}</span></p>
                                    <p className={"col-span-2"}>Quantidade: <span className={"info"}>{stolenItem?.quantity ?? ""}</span></p>
                                    <p>Unidade: <span className={"info"}>{BoKeys[stolenItem?.unit] ?? stolenItem?.unit ?? ""}</span></p>
                                </div>
                            </section>
                        </article>
                    )
                })
            }
        </>
    );
};

export default BoShowStolenItems;
